import React, { useEffect, useState } from "react";
import { NavigationalButtons } from "./CreateAudioWizard";
import { Form, Formik, useFormikContext } from "formik";
import useAxios from "axios-hooks";
import TextCKEditor from "../../../../Forms/TextCKEditor";
import { Label, Text } from "@fluentui/react";

const TranscriptFields = () => {
    const { values, setFieldValue } = useFormikContext();
    return (
        <div>
            <Label>Transcript <Text variant="small" styles={{ root: { color: "#605e5c", fontWeight: 400, display: "inline" } }}>(supports HTML formatting)</Text></Label>
            <Text variant="xSmall" styles={{ root: { color: "#605e5c", display: "block", marginBottom: 4 } }}>
                The transcript for the audio
            </Text>
            <TextCKEditor
                value={values.transcript || ""}
                onChange={(val) => setFieldValue("transcript", val)}
            />
        </div>
    );
};

const TranscriptStep = ({ audioId, nextOnClick, prevOnClick, transcript }) => {

    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `resources/audio/${audioId}/transcript`,
            method: "put",
        },
        { manual: true }
    );

    return (
        <div>
            <Formik
                initialValues={{ transcript: transcript}}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                <Form>
                    <TranscriptFields />
                    <NavigationalButtons
                        loading={submitting}
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default TranscriptStep;
